<template>
  <v-select
    v-model="inputValue"
    :items="schema.items"
    :label="schema.label"
    @change="emitInput()"
  ></v-select>
</template>

<script>
export default {
  name: 'RDSelectWidget',
  props: {
    schema: {
      type: Object,
      required: true
    },
    initialInput: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      inputValue: this.initialInput
    }
  },
  methods: {
    emitInput: function() {
      this.$emit('inputChange', this.inputValue)
    }
  }
}
</script>
